import { render, staticRenderFns } from "./TifTurnoOdometro.vue?vue&type=template&id=68a59ecd"
import script from "./TifTurnoOdometro.vue?vue&type=script&lang=js"
export * from "./TifTurnoOdometro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports